import { createAction } from 'redux-actions'

import * as constants from './constants'

export const setHandle = createAction(constants.SET_HANDLE)

export const createOrg = createAction(constants.CREATE_ORG)
export const createOrgSuccess = createAction(constants.CREATE_ORG_SUCCESS)
export const createOrgPending = createAction(constants.CREATE_ORG_PENDING)
export const createOrgFailed = createAction(constants.CREATE_ORG_FAILED)

export const signup = createAction(constants.SIGNUP)
export const signupSuccess = createAction(constants.SIGNUP_SUCCESS)
export const signupPending = createAction(constants.SIGNUP_PENDING)
export const signupFailed = createAction(constants.SIGNUP_FAILED)

export const updateOrg = createAction(constants.UPDATE_ORG)
export const updateOrgSuccess = createAction(constants.UPDATE_ORG_SUCCESS)
export const updateOrgPending = createAction(constants.UPDATE_ORG_PENDING)
export const updateOrgFailed = createAction(constants.UPDATE_ORG_FAILED)

export const fetchOrg = createAction(constants.FETCH_ORG)
export const fetchOrgSuccess = createAction(constants.FETCH_ORG_SUCCESS)
export const fetchOrgPending = createAction(constants.FETCH_ORG_PENDING)
export const fetchOrgFailed = createAction(constants.FETCH_ORG_FAILED)

export const fetchOrgPropertiesSuccess = createAction(constants.FETCH_ORG_PROPERTIES_SUCCESS)
export const fetchOrgPropertiesFailed = createAction(constants.FETCH_ORG_PROPERTIES_FAILED)

export const fetchOrgUsersSuccess = createAction(constants.FETCH_ORG_USERS_SUCCESS)
export const fetchOrgUsersPending = createAction(constants.FETCH_ORG_USERS_PENDING)
export const fetchOrgUsersFailed = createAction(constants.FETCH_ORG_USERS_FAILED)

export const setColor = createAction(constants.SET_COLOR)
export const setLocale = createAction(constants.SET_LOCALE)
export const setIcon = createAction(constants.SET_ICON)
export const setWelcomeMessage = createAction(constants.SET_WELCOME_MESSAGE)
export const setInstallOption = createAction(constants.SET_INSTALL_OPTION)
export const setCreateOrgError = createAction(constants.SET_CREATE_ORG_ERROR)
export const resetOrgError = createAction(constants.RESET_ORG_ERROR)
export const setOAuthError = createAction(constants.SET_OAUTH_ERROR)

export const updateOrgProperties = createAction(constants.UPDATE_ORG_PROPERTIES)
export const updateOrgPropertiesSuccess = createAction(constants.UPDATE_ORG_PROPERTIES_SUCCESS)
export const updateOrgPropertiesPending = createAction(constants.UPDATE_ORG_PROPERTIES_PENDING)
export const updateOrgPropertiesFailed = createAction(constants.UPDATE_ORG_PROPERTIES_FAILED)

export const updateOrgPropertiesExp = createAction(constants.UPDATE_ORG_PROPERTIES_EXP)

export const updateEmbed = createAction(constants.UPDATE_EMBED)
export const updateEmbedSuccess = createAction(constants.UPDATE_EMBED_SUCCESS)
export const updateEmbedPending = createAction(constants.UPDATE_EMBED_PENDING)
export const updateEmbedFailed = createAction(constants.UPDATE_EMBED_FAILED)

export const updateWelcomeMessage = createAction(constants.UPDATE_WELCOME_MESSAGE)
export const updateWelcomeMessageSuccess = createAction(constants.UPDATE_WELCOME_MESSAGE_SUCCESS)
export const updateWelcomeMessagePending = createAction(constants.UPDATE_WELCOME_MESSAGE_PENDING)
export const updateWelcomeMessageFailed = createAction(constants.UPDATE_WELCOME_MESSAGE_FAILED)

export const checkUniqueHandle = createAction(constants.CHECK_UNIQUE_HANDLE)
export const checkUniqueHandleSuccess = createAction(constants.CHECK_UNIQUE_HANDLE_SUCCESS)
export const checkUniqueHandleFailed = createAction(constants.CHECK_UNIQUE_HANDLE_FAILED)

export const fetchEmbed = createAction(constants.FETCH_EMBED)
export const fetchEmbedSuccess = createAction(constants.FETCH_EMBED_SUCCESS)
export const fetchEmbedPending= createAction(constants.FETCH_EMBED_PENDING)
export const fetchEmbedFailed = createAction(constants.FETCH_EMBED_FAILED)

export const exchangeGoogleCodeForDriftCode = createAction(constants.EXCHANGE_GOOGLE_CODE_FOR_DRIFT_CODE)
export const exchangeMicrosoftCodeForDriftCode = createAction(constants.EXCHANGE_MICROSOFT_CODE_FOR_DRIFT_CODE)
export const exchangeThirdPartyCodeSuccess = createAction(constants.EXCHANGE_THIRD_PARTY_CODE_SUCCESS)
export const thirdPartyOnboardingRedirect = createAction(constants.THIRD_PARTY_ONBOARDING_REDIRECT)
export const thirdPartyOnboardingSignIn = createAction(constants.THIRD_PARTY_ONBOARDING_SIGN_IN)



// WEBPACK FOOTER //
// ./src/modules/org/actions.js